import DragModal from "../../common/components/DragModal";
import {
  Divider,
  DialogContent,
  Box,
  Typography,
  Autocomplete,
  TextField,
  CircularProgress,
  createFilterOptions,
} from "@mui/material";
import { CodeLegendContext } from "../../common/contexts/CodeLegendContext";
import { useContext } from "react";
import CodeLegendEditor from "../../CodeLegends/components/CodeLegendEditor";

const CodeLegendSelector = ({
  open,
  selectedCodeLegend,
  setSelectedCodeLegend,
  onClose,
}) => {
  const { codeLegends } = useContext(CodeLegendContext);

  return (
    <DragModal
      open={open}
      onClose={() => {
        onClose(selectedCodeLegend);
      }}
      fullWidth
      maxWidth='lg'
      disablefocus='true'
      titlecomponent={
        <Typography variant='h5' color='primary'>
          Select/Manage Code Legend
        </Typography>
      }>
      <Divider />
      <DialogContent>
        <Box sx={{ minWidth: 300 }}>
          <Autocomplete
            value={
              selectedCodeLegend ?? {
                label: "None Selected",
                value: "None Selected",
                id: -1,
              }
            }
            onChange={(_, newValue) => {
              setSelectedCodeLegend(newValue);
            }}
            options={[
              ...codeLegends,
              { label: "None Selected", value: "None Selected", id: -1 },
            ]}
            getOptionLabel={(legend) => legend.label}
            getOptionKey={(legend) => legend.id}
            isOptionEqualToValue={(option, value) => {
              return option.value === value.value;
            }}
            disabled={codeLegends.length <= 1}
            filterOptions={createFilterOptions({
              matchFrom: "any",
              limit: 50,
            })}
            renderInput={(params) => (
              <TextField
                {...params}
                label='Code Legends'
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>{codeLegends.length <= 1 ? <CircularProgress /> : null}</>
                  ),
                }}
              />
            )}
          />
          <br />
          {selectedCodeLegend && selectedCodeLegend.id !== -1 ? (
            <CodeLegendEditor
              codeLegendId={selectedCodeLegend.id}
              onSaveAsNew={(newLegend) => {
                setSelectedCodeLegend({
                  label: newLegend.Title,
                  value: newLegend.Title,
                  id: newLegend.CodeLegendId,
                });
              }}
            />
          ) : null}
        </Box>
      </DialogContent>
    </DragModal>
  );
};

export default CodeLegendSelector;
